const getGcodeLineMethod = (line: string[]) => {
  if (line[0]?.startsWith('N')) {
    return line[1]
  }
  return line[0]
}

const getGcodeCoordinate = (line: string[], axis: 'X' | 'Y' | 'Z') => {
  return (
    (parseFloat(
      line.find(part => part.startsWith(axis))?.replace(axis, '') || '0',
    ) || 0) / 1000
  )
}

export const parseGcode = (gcode: string) => {
  const gcodeLines = gcode.split('\n')

  return gcodeLines.map((line) => {
    const currentLine = line.trim().split(' ')
    switch (getGcodeLineMethod(currentLine)) {
      case 'G0':
      case 'G1':
        return {
          method: getGcodeLineMethod(currentLine),
          x: getGcodeCoordinate(currentLine, 'X'),
          y: getGcodeCoordinate(currentLine, 'Y'),
          z: getGcodeCoordinate(currentLine, 'Z'),
          originalLine: line,
        }
      default:
        return {
          method: getGcodeLineMethod(currentLine),
          originalLine: line,
        }
    }
  })
}
